(() => {
  if (window.agaGiftLoaded) return;
  window.agaGiftLoaded = true;
  const query = (root, selector) => root.querySelector(selector);
  async function createPdf(root, values, sample) {
    if (root.dataset.currency !== 'EUR') throw new Error('currency');
    const design = values.design;
    if (!/^0[1-5]$/.test(design)) throw new Error('template');
    const [engine, template] = await Promise.all([import(root.dataset.engine), import(root.dataset['template' + design])]);
    const bytes = Uint8Array.from(atob(template.default), c => c.charCodeAt(0));
    return engine.makeGiftPdf(bytes, values, { sample });
  }
  function failure(root, error) {
    const output = query(root, '[data-gift-error]');
    const messages = JSON.parse(root.dataset.messages);
    output.textContent = messages[error.message] || messages.general;
    output.hidden = false;
    output.focus();
  }
  function clearError(root) { const output = query(root, '[data-gift-error]'); output.hidden = true; output.textContent = ''; }
  function savePdf(bytes, sample) {
    const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = sample ? 'MUSTER-Altes-Gewuerzamt.pdf' : 'Gutschein-Altes-Gewuerzamt.pdf';
    document.body.append(a); a.click(); a.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 60000);
  }
  function init() {
    document.querySelectorAll('[data-aga-gift]:not([data-initialized])').forEach(root => {
      root.dataset.initialized = 'true';
      const form = query(root, 'form');
      const zoomLink = query(root, '[data-gift-zoom-open]');
      const dialog = query(root, '[data-gift-zoom]');
      if (zoomLink && dialog) {
        const image = query(dialog, '[data-gift-zoom-image]');
        const scroller = query(dialog, '[data-gift-zoom-scroll]');
        const smaller = query(dialog, '[data-gift-zoom-out]');
        const larger = query(dialog, '[data-gift-zoom-in]');
        let scale = 1;
        const resize = () => {
          if (!dialog.open) return;
          const horizontalPadding = parseFloat(getComputedStyle(scroller).paddingLeft) + parseFloat(getComputedStyle(scroller).paddingRight);
          const verticalPadding = parseFloat(getComputedStyle(scroller).paddingTop) + parseFloat(getComputedStyle(scroller).paddingBottom);
          const fit = Math.min(scroller.clientWidth - horizontalPadding, (scroller.clientHeight - verticalPadding) * 595 / 842);
          image.style.width = `${Math.max(120, fit) * scale}px`;
          query(dialog, '[data-gift-zoom-level]').textContent = `${Math.round(scale * 100)}%`;
          smaller.disabled = scale <= 1;
          larger.disabled = scale >= 3;
        };
        zoomLink.addEventListener('click', event => {
          if (typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          const previewImage = query(root, '[data-gift-preview]');
          image.src = zoomLink.href;
          image.alt = previewImage.alt;
          query(dialog, '[data-gift-zoom-title]').textContent = previewImage.alt;
          scale = 1;
          dialog.showModal();
          document.documentElement.classList.add('aga-gift-zoom-open');
          resize();
          scroller.scrollTop = 0;
          scroller.scrollLeft = 0;
        });
        smaller.addEventListener('click', () => { scale = Math.max(1, scale - .5); resize(); });
        larger.addEventListener('click', () => { scale = Math.min(3, scale + .5); resize(); });
        query(dialog, '[data-gift-zoom-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => { document.documentElement.classList.remove('aga-gift-zoom-open'); zoomLink.focus({ preventScroll: true }); });
        window.addEventListener('resize', resize);
      }
      if (form) {
        const recipient = query(root, '[data-recipient-fields]');
        const sync = () => {
          for (const field of ['_aga_pdf_sender', '_aga_pdf_recipient']) {
            const input = query(form, `[name="properties[${field}]"]`);
            input.setCustomValidity(input.value && !input.value.trim() ? root.dataset.requiredName : '');
          }
          const direct = query(form, '[name="aga-delivery"]:checked').value === 'recipient';
          recipient.hidden = !direct;
          recipient.querySelectorAll('input').forEach(input => { input.disabled = !direct; if (input.type === 'email') input.required = direct; });
          query(form, '[data-recipient-name]').value = query(form, '[name="properties[_aga_pdf_recipient]"]').value;
          const selected = query(form, '[name="properties[_aga_pdf_design]"]:checked');
          query(root, '[data-gift-preview]').src = selected.dataset.preview;
          query(root, '[data-gift-preview]').alt = `${root.dataset.designPrefix} ${selected.dataset.designLabel}`;
          if (zoomLink) zoomLink.href = selected.dataset.detail;
        };
        form.addEventListener('change', sync); sync();
        function values() {
          const fd = new FormData(form);
          const option = query(form, '[name=id]').selectedOptions[0];
          return { design: fd.get('properties[_aga_pdf_design]'), Fuer: fd.get('properties[_aga_pdf_recipient]'), Von: fd.get('properties[_aga_pdf_sender]'), Nachricht: fd.get('properties[Message]'), Wert: option.dataset.amount, Code: 'MUSTER-KEIN-GUTHABEN', Gueltig: root.dataset.sampleValidity };
        }
        const preview = query(root, '[data-gift-sample]');
        const submit = query(form, '[type=submit]');
        preview.addEventListener('click', async () => {
          clearError(root); preview.disabled = true;
          try { savePdf(await createPdf(root, values(), true), true); }
          catch (error) { failure(root, error); }
          finally { preview.disabled = false; }
        });
        let approvedSnapshot = null;
        let validating = false;
        const serialize = () => JSON.stringify(Array.from(new FormData(form).entries()));
        form.addEventListener('input', () => { approvedSnapshot = null; clearError(root); sync(); });
        form.addEventListener('submit', async event => {
          sync();
          const snapshot = serialize();
          if (!root.dataset.orderingDisabled && approvedSnapshot === snapshot) {
            approvedSnapshot = null;
            return;
          }
          event.preventDefault();
          event.stopImmediatePropagation();
          if (root.dataset.orderingDisabled || validating || !form.reportValidity()) return;
          clearError(root);
          validating = true;
          submit.disabled = true;
          try {
            await createPdf(root, values(), true);
            validating = false;
            submit.disabled = false;
            if (serialize() !== snapshot || !form.reportValidity()) return;
            approvedSnapshot = snapshot;
            form.requestSubmit(submit);
          } catch (error) {
            approvedSnapshot = null;
            validating = false;
            submit.disabled = false;
            failure(root, error);
          }
        }, { capture: true });
        submit.disabled = Boolean(root.dataset.orderingDisabled);
      } else {
        const button = query(root, '[data-gift-download]');
        if (!button) return;
        button.addEventListener('click', async () => {
          clearError(root); button.disabled = true;
          try {
            const values = JSON.parse(query(root, '[data-gift-values]').textContent);
            savePdf(await createPdf(root, values, false), false);
          } catch (error) { failure(root, error); }
          finally { button.disabled = false; }
        });
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();




